/* eslint-disable jsx-a11y/label-has-associated-control */
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Paperclip } from "react-feather";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import modulos from "../../../mocks/modulos";
import { useAuth } from "../../../context/AuthContext";
import { fetchTemplateMessageTicketing, postMessageTicketing } from "../../../services/messageTicketingService";
import ConfirmarMensajeModal from "../ConfirmMsgModal";
import { ButtonPrimary, IconButton } from "../../../ui/buttons";
import { CustomToolBarGroup } from "./styles";
import MessageTypeButtons from "./MessageTypeButtons";
import { InputTextAreaEditorContainer } from "../../../ui/inputs";
import { RedSelect } from "../../../ui/redSelect";

const ReplyMessage = ({ ticketId, ticket, messages, lastMessageId, isConversationRoot, addMessage, changeReplyMessage, isReplyMessage, setReplyType, replyTypeChat }) => {
  const { currentUser } = useAuth();
  const [replyTemplates] = useFetcher(fetchTemplateMessageTicketing, undefined, "fetchTemplateMessageTicketing");
  const [isLoadingEditor, setIsLoadingEditor] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [confirmMsg, setconfirmMsg] = useState(false);
  const publicoText = ticket.categoriaCat ? ticket.categoriaCat.text : "";

  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.TICKETING);

  const handleConfirmSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleUploadFileButton = () => {
    document.getElementById("upfile").click();
  };

  const getLastSubject = () => {
    const lastMessage = messages.find((msg) => msg.id === lastMessageId);
    return lastMessage ? lastMessage.subject : "no subject";
  };

  const filterByPublicoCat = (list) => {
    const exist = list.find((item) => item.text === publicoText);
    return !!exist;
  };

  const templateOptions = replyTemplates
    ? replyTemplates
        .filter((item) => item.titulo !== "" && item.publico)
        .filter((item) => filterByPublicoCat(item.publicoCat))
        .map((item) => {
          return { label: item.titulo, value: item.cuerpoDelEmail, asunto: item.asunto };
        })
    : [];

  const getEmailInvolucrados = () => {
    if (messages.length > 0) {
      const { from } = messages[0];
      let tos = [];
      if (messages[0].to && messages[0].to.length > 0) {
        const toList = messages[0].to;
        tos = toList.map((item) => {
          return item.email;
        });
      }
      return [].concat(tos).concat(from);
    }
    return [];
  };

  const formik = useFormik({
    initialValues: {
      subject: getLastSubject(),
      body: "",
      to: getEmailInvolucrados(),
      replyMessageId: lastMessageId,
      isSolucion: false,
    },
    onSubmit: async (newMessage) => {
      setIsLoadingEditor(true);
      try {
        const { message, result } = await postMessageTicketing(ticketId, {
          ...newMessage,
          files: document.getElementById("upfile").files,
        });
        addMessage(result.messages[0]);
        changeReplyMessage(false);
        toast.success(message);
      } catch (error) {
        handleErrors(error);
      } finally {
        setIsLoadingEditor(false);
      }
    },
    validationSchema: Yup.object().shape({
      body: Yup.string().typeError("Debe escribir el mensaje").required("Este campo es requerido."),
    }),
  });

  const handleChangeTemplate = (event) => {
    const { asunto, value } = event;
    formik.setFieldValue("subject", asunto || getLastSubject());
    formik.setFieldValue("body", value);
  };

  return (
    <>
      {confirmMsg ? <ConfirmarMensajeModal toggle={() => setconfirmMsg(!confirmMsg)} handleSubmitMessage={formik.handleSubmit} /> : null}
      <BlurSpinner isLoading={isLoadingEditor}>
        <div className="p-2 pt-0">
          <div style={{ maxHeight: "500px" }}>
            <div>
              <CustomToolBarGroup>
                <MessageTypeButtons changeReplyMessage={changeReplyMessage} isReplyMessage={isReplyMessage} setReplyType={setReplyType} replyTypeChat={replyTypeChat} />
                <div
                  style={{
                    width: "1px",
                    height: "24px",
                    backgroundColor: "#ccc",
                    margin: "0 10px",
                  }}
                />
                <div className="d-flex align-items-center w-100" style={{ gap: "10px" }}>
                  {isAdmin && (
                    <div className="flex-grow-1 position-relative z-index-10" style={{ minWidth: "150px" }}>
                      <RedSelect
                        defaultValue={formik.values.template}
                        name="template"
                        className="w-100"
                        placeholder="Plantilla"
                        options={templateOptions}
                        onChange={handleChangeTemplate}
                        onBlur={() => formik.setFieldTouched("template")}
                        isClearable={false}
                      />
                    </div>
                  )}

                  <div className="position-relative d-flex align-items-center" style={{ flexGrow: 1, minWidth: "150px" }}>
                    <div className="d-none">
                      <input
                        id="upfile"
                        name="upfile"
                        type="file"
                        onChange={handleConfirmSelectedFiles}
                        multiple
                        accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      />
                    </div>

                    <IconButton onClick={handleUploadFileButton} className="position-relative">
                      <Paperclip size="24" />
                    </IconButton>

                    {selectedFiles.length > 0 && (
                      <div className="ml-2" style={{ flexGrow: 1, maxWidth: "100%", overflow: "hidden" }}>
                        {Array.from(selectedFiles).map((file) => (
                          <p
                            className="mb-0"
                            style={{
                              fontSize: "10px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            key={file.name}
                          >
                            {file.name}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </CustomToolBarGroup>

              <InputTextAreaEditorContainer className="mb-1 custom-scrollbar" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                <CKEditor
                  className="text-dark"
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                  }}
                  data={formik.values.body}
                  onReady={() => setIsLoadingEditor(false)}
                  onChange={(event, editor) => formik.setFieldValue("body", editor.getData())}
                  onBlur={() => formik.setFieldTouched("body")}
                />
              </InputTextAreaEditorContainer>

              {isConversationRoot && (
                <>
                  <label className="d-flex align-items-center m-0" htmlFor="isSolucion" style={{ fontFamily: "Nunito", fontSize: "12px", color: "var(--secondary)" }}>
                    <input
                      className="checkbox_red"
                      id="isSolucion"
                      name="isSolucion"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.isSolucion}
                    />
                    Marcar como solución
                  </label>
                </>
              )}

              <div className="d-flex justify-content-end w-100">
                <ButtonPrimary type="button" onClick={() => setconfirmMsg(!confirmMsg)} disabled={formik.errors.body || formik.values.body === ""}>
                  Enviar
                </ButtonPrimary>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default ReplyMessage;
